import { render, staticRenderFns } from "./TrainyudingshenqingRight.vue?vue&type=template&id=4408c858&scoped=true"
import script from "./TrainyudingshenqingRight.vue?vue&type=script&lang=js"
export * from "./TrainyudingshenqingRight.vue?vue&type=script&lang=js"
import style0 from "./TrainyudingshenqingRight.vue?vue&type=style&index=0&id=4408c858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4408c858",
  null
  
)

export default component.exports